export default "__VITE_ASSET__BDd7z3gx__"